import { ControlList, Dialog, useUrlParamsValueToString } from "@bsm/component";
import { useNavigate, useParams } from "react-router-dom";
import { useSchoolHolidayCreateForm } from "../hooks/useSchoolHolidayCreateForm";
import { useQueryClient } from "react-query";
import moment from "moment";

export const SchoolHolidayCreateContainer = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const urlParams = useUrlParamsValueToString();
    const forms = useSchoolHolidayCreateForm(id ? parseInt(id) : undefined);
    const queryClient = useQueryClient()

    const handleSuccess = () => {
        navigate(`..?${urlParams}`);
        queryClient.invalidateQueries("App.Bsm.Holiday")
    };

    const handleCancel = () => {
        navigate(`..?${urlParams}`);
    };

    return (
        <Dialog open onClose={handleCancel}>            
            <ControlList
                {...forms}
                defaultValue={{
                    startDate: moment().format(),
                    endDate: moment().format(),
                }}
                onCancel={handleCancel}
                onSubmited={handleSuccess}
            />
        </Dialog>
    );
};

const i18n = [
    "BSMRH.Holiday.Create.Title",
    "BSMRH.Holiday.Edit.Title",
];